import React, { useState, useEffect } from 'react';
import { useSettingsMutation, useUpdateSettingsMutation } from "../redux/features/user/userApi";
import Navbar from "../Components/Navbar";

const Settings = () => {
    const [settings, setSettings] = useState(null);
    const [updateSettings, { isLoading: isUpdating }] = useUpdateSettingsMutation();
    const [fetchSettings] = useSettingsMutation();
    const [form, setForm] = useState({});
    const [success, setSuccess] = useState("");
    const [activeTab, setActiveTab] = useState('general');

    useEffect(() => {
        fetchSettings().then((res) => {
            if (res?.data?.data) {
                setSettings(res.data.data);
                setForm(res.data.data); // Initialize form with current settings
            }
        });
    }, [fetchSettings]);

    const handleChange = (e) => {
        const { name, value, type, checked } = e.target;
        setForm(prev => ({
            ...prev,
            [name]: type === 'checkbox' ? checked : value
        }));
    };

    const handleSocialMediaChange = (index, field, value) => {
        const updatedSocialMedia = [...(form.social_media || [])];
        updatedSocialMedia[index][field] = value;
        setForm(prev => ({
            ...prev,
            social_media: updatedSocialMedia
        }));
    };

    // Add new social media link
    const handleAddSocialMedia = () => {
        setForm(prev => ({
            ...prev,
            social_media: [
                ...(prev.social_media || []),
                { Category: '', Link: '' }
            ]
        }));
    };

    // Remove social media link by index
    const handleRemoveSocialMedia = (index) => {
        setForm(prev => ({
            ...prev,
            social_media: prev.social_media.filter((_, i) => i !== index)
        }));
    };

    const handleSubmit = async (e) => {
        e.preventDefault();
        setSuccess("");
        try {
            const res = await updateSettings(form);
            if (res?.data?.status) {
                setSuccess("Settings updated successfully!");
                setTimeout(() => setSuccess(""), 3000);
            }
        } catch (err) {
            console.log(err);
        }
    };

    if (!settings) {
        return (
            <div className="min-h-screen flex items-center justify-center bg-blue-50">
                <div className="text-lg text-gray-700">Loading settings...</div>
            </div>
        );
    }

    return (
        <>
            <Navbar />
            <div className="min-h-screen bg-blue-50 transition-colors py-8 px-4">
                <div className="max-w-6xl mx-auto bg-white rounded-lg shadow-lg overflow-hidden">
                    <div className="flex flex-col md:flex-row">
                        {/* Sidebar Navigation */}
                        <div className="w-full md:w-64 bg-gray-100 p-4">
                            <h2 className="text-xl font-bold mb-6 text-blue-900">Settings</h2>
                            <nav className="space-y-2">
                                <button
                                    onClick={() => setActiveTab('general')}
                                    className={`w-full text-left px-4 py-2 rounded ${activeTab === 'general' ? 'bg-blue-600 text-white' : 'text-gray-700 hover:bg-gray-200'}`}
                                >
                                    General Settings
                                </button>
                                <button
                                    onClick={() => setActiveTab('payment')}
                                    className={`w-full text-left px-4 py-2 rounded ${activeTab === 'payment' ? 'bg-blue-600 text-white' : 'text-gray-700 hover:bg-gray-200'}`}
                                >
                                    Payment Settings
                                </button>
                                <button
                                    onClick={() => setActiveTab('security')}
                                    className={`w-full text-left px-4 py-2 rounded ${activeTab === 'security' ? 'bg-blue-600 text-white' : 'text-gray-700 hover:bg-gray-200'}`}
                                >
                                    Security Settings
                                </button>
                                {/* <button
                                    onClick={() => setActiveTab('social')}
                                    className={`w-full text-left px-4 py-2 rounded ${activeTab === 'social' ? 'bg-blue-600 text-white' : 'text-gray-700 hover:bg-gray-200'}`}
                                >
                                    Social Media
                                </button> */}
                            </nav>
                        </div>

                        {/* Main Content */}
                        <div className="flex-1 p-6">
                            {success && (
                                <div className="mb-4 p-3 bg-green-100 text-green-700 rounded">
                                    {success}
                                </div>
                            )}

                            <form onSubmit={handleSubmit}>
                                {/* General Settings Tab */}
                                {activeTab === 'general' && (
                                    <div>
                                        <h3 className="text-lg font-semibold mb-4 text-blue-900">General Settings</h3>
                                        <div className="grid grid-cols-1 md:grid-cols-2 gap-6">
                                            <div>
                                                <label className="block text-sm font-medium text-gray-700 mb-1">Site Name</label>
                                                <input
                                                    type="text"
                                                    name="sitename"
                                                    value={form.sitename || ''}
                                                    onChange={handleChange}
                                                    className="w-full px-3 py-2 border border-gray-300 rounded-md shadow-sm focus:outline-none focus:ring-blue-500 focus:border-blue-500"
                                                />
                                            </div>
                                            <div>
                                                <label className="block text-sm font-medium text-gray-700 mb-1">Site Link</label>
                                                <input
                                                    type="text"
                                                    name="sitelink"
                                                    value={form.sitelink || ''}
                                                    onChange={handleChange}
                                                    className="w-full px-3 py-2 border border-gray-300 rounded-md shadow-sm focus:outline-none focus:ring-blue-500 focus:border-blue-500"
                                                />
                                            </div>
                                            <div>
                                                <label className="block text-sm font-medium text-gray-700 mb-1">Copyright Text</label>
                                                <input
                                                    type="text"
                                                    name="copyright"
                                                    value={form.copyright || ''}
                                                    onChange={handleChange}
                                                    className="w-full px-3 py-2 border border-gray-300 rounded-md shadow-sm focus:outline-none focus:ring-blue-500 focus:border-blue-500"
                                                />
                                            </div>
                                            <div>
                                                <label className="block text-sm font-medium text-gray-700 mb-1">Contact Email</label>
                                                <input
                                                    type="email"
                                                    name="contactEmail"
                                                    value={form.contactEmail || ''}
                                                    onChange={handleChange}
                                                    className="w-full px-3 py-2 border border-gray-300 rounded-md shadow-sm focus:outline-none focus:ring-blue-500 focus:border-blue-500"
                                                />
                                            </div>
                                            <div>
                                                <label className="block text-sm font-medium text-gray-700 mb-1">Mobile Number</label>
                                                <input
                                                    type="text"
                                                    name="mobile"
                                                    value={form.mobile || ''}
                                                    onChange={handleChange}
                                                    className="w-full px-3 py-2 border border-gray-300 rounded-md shadow-sm focus:outline-none focus:ring-blue-500 focus:border-blue-500"
                                                />
                                            </div>
                                            {/* <div>
                                                <label className="block text-sm font-medium text-gray-700 mb-1">Logo URL</label>
                                                <input
                                                    type="text"
                                                    name="logo"
                                                    value={form.logo || ''}
                                                    onChange={handleChange}
                                                    className="w-full px-3 py-2 border border-gray-300 rounded-md shadow-sm focus:outline-none focus:ring-blue-500 focus:border-blue-500"
                                                />
                                            </div> */}
                                            <div>
                                                <label className="block text-sm font-medium text-gray-700 mb-1">Per Unit Inr Price</label>
                                                <input
                                                    type="number"
                                                    name="perunit"
                                                    value={form.perunit}
                                                    onChange={handleChange}
                                                    className="w-full px-3 py-2 border border-gray-300 rounded-md shadow-sm focus:outline-none focus:ring-blue-500 focus:border-blue-500"
                                                />
                                            </div>
                                            <div>
                                                <label className="block text-sm font-medium text-gray-700 mb-1">Minimum Stake</label>
                                                <input
                                                    type="number"
                                                    name="minstake"
                                                    value={form.minstake}
                                                    onChange={handleChange}
                                                    className="w-full px-3 py-2 border border-gray-300 rounded-md shadow-sm focus:outline-none focus:ring-blue-500 focus:border-blue-500"
                                                />
                                            </div>
                                            <div>
                                                <label className="block text-sm font-medium text-gray-700 mb-1">NFT Count</label>
                                                <input
                                                    type="number"
                                                    name="nft_count"
                                                    value={form.nft_count || ''}
                                                    onChange={handleChange}
                                                    className="w-full px-3 py-2 border border-gray-300 rounded-md shadow-sm focus:outline-none focus:ring-blue-500 focus:border-blue-500"
                                                />
                                            </div>
                                            <div className="flex items-center">
                                                <input
                                                    type="checkbox"
                                                    name="inr_withdraw"
                                                    checked={form.inr_withdraw}
                                                    onChange={handleChange}
                                                    className="h-4 w-4 text-blue-600 focus:ring-blue-500 border-gray-300 rounded"
                                                />
                                                <label className="ml-2 block text-sm text-gray-700">Inr withdraw Enable</label>
                                            </div>
                                            <div className="flex items-center">
                                                <input
                                                    type="checkbox"
                                                    name="kait_withdraw"
                                                    checked={form.kait_withdraw}
                                                    onChange={handleChange}
                                                    className="h-4 w-4 text-blue-600 focus:ring-blue-500 border-gray-300 rounded"
                                                />
                                                <label className="ml-2 block text-sm text-gray-700">Kait withdraw Enable</label>
                                            </div>
                                            <div>
                                                <label className="block text-sm font-medium text-gray-700 mb-1">Min Amount For INR withdraw</label>
                                                <input
                                                    type="number"
                                                    name="min_inr_withdraw"
                                                    value={form.min_inr_withdraw || ''}
                                                    onChange={handleChange}
                                                    className="w-full px-3 py-2 border border-gray-300 rounded-md shadow-sm focus:outline-none focus:ring-blue-500 focus:border-blue-500"
                                                />
                                            </div>
                                            <div>
                                                <label className="block text-sm font-medium text-gray-700 mb-1">Min Amount For KAIT withdraw</label>
                                                <input
                                                    type="number"
                                                    name="min_kait_withdraw"
                                                    value={form.min_kait_withdraw || ''}
                                                    onChange={handleChange}
                                                    className="w-full px-3 py-2 border border-gray-300 rounded-md shadow-sm focus:outline-none focus:ring-blue-500 focus:border-blue-500"
                                                />
                                            </div>
                                            <div>
                                                <label className="block text-sm font-medium text-gray-700 mb-1">Maintanance_fees_inr(flat)</label>
                                                <input
                                                    type="number"
                                                    name="maintanance_fees_inr"
                                                    value={form.maintanance_fees_inr || ''}
                                                    onChange={handleChange}
                                                    className="w-full px-3 py-2 border border-gray-300 rounded-md shadow-sm focus:outline-none focus:ring-blue-500 focus:border-blue-500"
                                                />
                                            </div>
                                          
                                            <div>
                                                <label className="block text-sm font-medium text-gray-700 mb-1">Maintanance_fees_kait(flat)</label>
                                                <input
                                                    type="number"
                                                    name="maintanance_fees_kait"
                                                    value={form.maintanance_fees_kait || ''}
                                                    onChange={handleChange}
                                                    className="w-full px-3 py-2 border border-gray-300 rounded-md shadow-sm focus:outline-none focus:ring-blue-500 focus:border-blue-500"
                                                />
                                            </div>
                                            <div className="flex items-center">
                                                <input
                                                    type="checkbox"
                                                    name="sitemode"
                                                    checked={form.sitemode}
                                                    onChange={handleChange}
                                                    className="h-4 w-4 text-blue-600 focus:ring-blue-500 border-gray-300 rounded"
                                                />
                                                <label className="ml-2 block text-sm text-gray-700">Site Maintenance Mode</label>
                                            </div>
                                            <div className="flex items-center">
                                                <input
                                                    type="checkbox"
                                                    name="stake"
                                                    checked={form.stake}
                                                    onChange={handleChange}
                                                    className="h-4 w-4 text-blue-600 focus:ring-blue-500 border-gray-300 rounded"
                                                />
                                                <label className="ml-2 block text-sm text-gray-700">Site Staking function
                                                </label>
                                            </div>
                                        </div>
                                    </div>
                                )}

                                {/* Payment Settings Tab */}
                                {activeTab === 'payment' && (
                                    <div>
                                        <h3 className="text-lg font-semibold mb-4 text-blue-900">Payment Settings</h3>
                                        <div className="grid grid-cols-1 md:grid-cols-2 gap-6">
                                            <div className="border p-4 rounded-lg">
                                                <h4 className="font-medium mb-3 text-gray-700">Fiat Currency</h4>
                                                <div className="space-y-3">
                                                    <div className="flex items-center">
                                                        <input
                                                            type="checkbox"
                                                            name="fiat.deposit"
                                                            checked={form.fiat?.deposit || false}
                                                            onChange={(e) => {
                                                                setForm(prev => ({
                                                                    ...prev,
                                                                    fiat: {
                                                                        ...prev.fiat,
                                                                        deposit: e.target.checked
                                                                    }
                                                                }));
                                                            }}
                                                            className="h-4 w-4 text-blue-600 focus:ring-blue-500 border-gray-300 rounded"
                                                        />
                                                        <label className="ml-2 block text-sm text-gray-700">Enable Deposits</label>
                                                    </div>
                                                    <div className="flex items-center">
                                                        <input
                                                            type="checkbox"
                                                            name="fiat.withdraw"
                                                            checked={form.fiat?.withdraw || false}
                                                            onChange={(e) => {
                                                                setForm(prev => ({
                                                                    ...prev,
                                                                    fiat: {
                                                                        ...prev.fiat,
                                                                        withdraw: e.target.checked
                                                                    }
                                                                }));
                                                            }}
                                                            className="h-4 w-4 text-blue-600 focus:ring-blue-500 border-gray-300 rounded"
                                                        />
                                                        <label className="ml-2 block text-sm text-gray-700">Enable Withdrawals</label>
                                                    </div>
                                                </div>
                                            </div>
                                            <div className="border p-4 rounded-lg">
                                                <h4 className="font-medium mb-3 text-gray-700">Cryptocurrency</h4>
                                                <div className="space-y-3">
                                                    <div className="flex items-center">
                                                        <input
                                                            type="checkbox"
                                                            name="crypto.deposit"
                                                            checked={form.crypto?.deposit || false}
                                                            onChange={(e) => {
                                                                setForm(prev => ({
                                                                    ...prev,
                                                                    crypto: {
                                                                        ...prev.crypto,
                                                                        deposit: e.target.checked
                                                                    }
                                                                }));
                                                            }}
                                                            className="h-4 w-4 text-blue-600 focus:ring-blue-500 border-gray-300 rounded"
                                                        />
                                                        <label className="ml-2 block text-sm text-gray-700">Enable Deposits</label>
                                                    </div>
                                                    <div className="flex items-center">
                                                        <input
                                                            type="checkbox"
                                                            name="crypto.withdraw"
                                                            checked={form.crypto?.withdraw || false}
                                                            onChange={(e) => {
                                                                setForm(prev => ({
                                                                    ...prev,
                                                                    crypto: {
                                                                        ...prev.crypto,
                                                                        withdraw: e.target.checked
                                                                    }
                                                                }));
                                                            }}
                                                            className="h-4 w-4 text-blue-600 focus:ring-blue-500 border-gray-300 rounded"
                                                        />
                                                        <label className="ml-2 block text-sm text-gray-700">Enable Withdrawals</label>
                                                    </div>
                                                </div>
                                            </div>
                                            <div className="border p-4 rounded-lg">
                                                <h4 className="font-medium mb-3 text-gray-700">TDS Settings</h4>
                                                <div className="space-y-3">
                                                    <div className="flex items-center">
                                                        <input
                                                            type="checkbox"
                                                            name="tds_deposit"
                                                            checked={form.tds_deposit || false}
                                                            onChange={handleChange}
                                                            className="h-4 w-4 text-blue-600 focus:ring-blue-500 border-gray-300 rounded"
                                                        />
                                                        <label className="ml-2 block text-sm text-gray-700">Enable TDS on Deposits</label>
                                                    </div>
                                                    <div className="flex items-center">
                                                        <input
                                                            type="checkbox"
                                                            name="tds_withdraw"
                                                            checked={form.tds_withdraw || false}
                                                            onChange={handleChange}
                                                            className="h-4 w-4 text-blue-600 focus:ring-blue-500 border-gray-300 rounded"
                                                        />
                                                        <label className="ml-2 block text-sm text-gray-700">Enable TDS on Withdrawals</label>
                                                    </div>
                                                </div>
                                            </div>
                                            {/* <div className="border p-4 rounded-lg">
                                                <h4 className="font-medium mb-3 text-gray-700">Bonus Settings</h4>
                                                <div className="space-y-3">
                                                    <div>
                                                        <label className="block text-sm font-medium text-gray-700 mb-1">Total Bonus Limit</label>
                                                        <input
                                                            type="number"
                                                            name="total_bonus_limit"
                                                            value={form.total_bonus_limit || ''}
                                                            onChange={handleChange}
                                                            className="w-full px-3 py-2 border border-gray-300 rounded-md shadow-sm focus:outline-none focus:ring-blue-500 focus:border-blue-500"
                                                        />
                                                    </div>
                                                    <div>
                                                        <label className="block text-sm font-medium text-gray-700 mb-1">Bonus Spent Limit</label>
                                                        <input
                                                            type="number"
                                                            name="bonus_spent_limit"
                                                            value={form.bonus_spent_limit || ''}
                                                            onChange={handleChange}
                                                            className="w-full px-3 py-2 border border-gray-300 rounded-md shadow-sm focus:outline-none focus:ring-blue-500 focus:border-blue-500"
                                                        />
                                                    </div>
                                                </div>
                                            </div>
                                            <div className="border p-4 rounded-lg">
                                                <h4 className="font-medium mb-3 text-gray-700">Other Settings</h4>
                                                <div className="space-y-3">
                                                    <div>
                                                        <label className="block text-sm font-medium text-gray-700 mb-1">Referral Commission (%)</label>
                                                        <input
                                                            type="number"
                                                            name="referral_commission"
                                                            value={form.referral_commission || ''}
                                                            onChange={handleChange}
                                                            className="w-full px-3 py-2 border border-gray-300 rounded-md shadow-sm focus:outline-none focus:ring-blue-500 focus:border-blue-500"
                                                        />
                                                    </div>
                                                    <div>
                                                        <label className="block text-sm font-medium text-gray-700 mb-1">Per Unit Price</label>
                                                        <input
                                                            type="number"
                                                            name="perunit"
                                                            value={form.perunit || ''}
                                                            onChange={handleChange}
                                                            className="w-full px-3 py-2 border border-gray-300 rounded-md shadow-sm focus:outline-none focus:ring-blue-500 focus:border-blue-500"
                                                        />
                                                    </div>
                                                </div>
                                            </div> */}
                                        </div>
                                    </div>
                                )}

                                {/* Security Settings Tab */}
                                {activeTab === 'security' && (
                                    <div>
                                        <h3 className="text-lg font-semibold mb-4 text-blue-900">Security Settings</h3>
                                        <div className="grid grid-cols-1 md:grid-cols-2 gap-6">
                                            <div className="flex items-center">
                                                <input
                                                    type="checkbox"
                                                    name="verifyKYC"
                                                    checked={form.verifyKYC || false}
                                                    onChange={handleChange}
                                                    className="h-4 w-4 text-blue-600 focus:ring-blue-500 border-gray-300 rounded"
                                                />
                                                <label className="ml-2 block text-sm text-gray-700">Enable KYC Verification</label>
                                            </div>
                                            <div className="flex items-center">
                                                <input
                                                    type="checkbox"
                                                    name="verifyTFA"
                                                    checked={form.verifyTFA || false}
                                                    onChange={handleChange}
                                                    className="h-4 w-4 text-blue-600 focus:ring-blue-500 border-gray-300 rounded"
                                                />
                                                <label className="ml-2 block text-sm text-gray-700">Enable Two-Factor Authentication</label>
                                            </div>
                                            <div className="flex items-center">
                                                <input
                                                    type="checkbox"
                                                    name="TFA_enable"
                                                    checked={form.TFA_enable || false}
                                                    onChange={handleChange}
                                                    className="h-4 w-4 text-blue-600 focus:ring-blue-500 border-gray-300 rounded"
                                                />
                                                <label className="ml-2 block text-sm text-gray-700">Force TFA for All Users</label>
                                            </div>
                                        </div>
                                    </div>
                                )}

                                {/* Social Media Tab */}
                                {activeTab === 'social' && (
                                    <div>
                                        <h3 className="text-lg font-semibold mb-4 text-blue-900">Social Media Links</h3>
                                        <div className="space-y-4">
                                            {form.social_media?.map((social, index) => (
                                                <div key={index} className="border p-4 rounded-lg relative">
                                                    <button
                                                        type="button"
                                                        onClick={() => handleRemoveSocialMedia(index)}
                                                        className="absolute top-2 right-2 text-red-500 hover:text-red-700 text-xs font-bold px-2 py-1 rounded"
                                                        title="Remove"
                                                    >
                                                        Remove
                                                    </button>
                                                    <div className="mb-3">
                                                        <label className="block text-sm font-medium text-gray-700 mb-1">Platform</label>
                                                        <input
                                                            type="text"
                                                            value={social.Category || ''}
                                                            onChange={(e) => handleSocialMediaChange(index, 'Category', e.target.value)}
                                                            className="w-full px-3 py-2 border border-gray-300 rounded-md shadow-sm focus:outline-none focus:ring-blue-500 focus:border-blue-500"
                                                        />
                                                    </div>
                                                    <div>
                                                        <label className="block text-sm font-medium text-gray-700 mb-1">Link</label>
                                                        <input
                                                            type="url"
                                                            value={social.Link || ''}
                                                            onChange={(e) => handleSocialMediaChange(index, 'Link', e.target.value)}
                                                            className="w-full px-3 py-2 border border-gray-300 rounded-md shadow-sm focus:outline-none focus:ring-blue-500 focus:border-blue-500"
                                                        />
                                                    </div>
                                                </div>
                                            ))}
                                        </div>
                                        <button
                                            type="button"
                                            onClick={handleAddSocialMedia}
                                            className="mt-4 px-4 py-2 bg-blue-500 text-white rounded hover:bg-blue-600 focus:outline-none focus:ring-2 focus:ring-blue-400"
                                        >
                                            Add Social Media
                                        </button>
                                    </div>
                                )}

                                <div className="mt-8">
                                    <button
                                        type="submit"
                                        disabled={isUpdating}
                                        className="w-full flex justify-center py-2 px-4 border border-transparent rounded-md shadow-sm text-sm font-medium text-white bg-blue-600 hover:bg-blue-700 focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-blue-500 disabled:opacity-50"
                                    >
                                        {isUpdating ? 'Saving...' : 'Save Settings'}
                                    </button>
                                </div>
                            </form>
                        </div>
                    </div>
                </div>
            </div>
        </>
    );
};

export default Settings; 